// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unlockable-slider[data-v-31770c9e]{position:relative}.light-mode .unlockable-slider[data-v-31770c9e]{background:#fff}.dark-mode .unlockable-slider[data-v-31770c9e]{background:#191718}.unlockable-slider-inner[data-v-31770c9e]{position:absolute;left:-1px;top:-1px;background:#ff7ac3}.slider-bar[data-v-31770c9e]{border-radius:2.5rem;height:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
